import { Link, useLocation } from 'react-router-dom';

/**
 * Link para uma seção da home (#sobre, #contato...).
 *
 * Na própria home usa âncora nativa — a rolagem fica a cargo do navegador,
 * que já respeita o `scroll-padding-top` do header fixo. Nas páginas de área
 * vira um link de rota para "/#secao", senão o clique só trocaria o hash da
 * URL atual sem sair do lugar.
 */
export default function LinkSecao({ secao, children, ...rest }) {
  const { pathname } = useLocation();

  if (pathname === '/') {
    return (
      <a href={`#${secao}`} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link to={`/#${secao}`} {...rest}>
      {children}
    </Link>
  );
}
